import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
//import './index.css';
import reportWebVitals from './reportWebVitals';
import { Post } from './utils/api';
import KitaharaPage from './components/kitahara/KitaharaPage';
import ColorfulLoading from './images/ColorfulLoading';
import KitaharaChatPage from './components/kitahara/chat/KitaharaChatPage';
import KancollePage from './components/kancolle/KancollePage';

const kitaharaDomains = ["kitahara.maidchan.com"];
const chatDomains = ["kitahara-chat.maidchan.com"];
const kancolleDomains = ["kancolle.maidchan.com"];
// kancolleDomains.push("localhost");

if (chatDomains.includes(window.location.hostname)) {
	ReactDOM.render(
		<React.StrictMode>
			<Suspense fallback={<ColorfulLoading />}>
				<KitaharaChatPage loading={<ColorfulLoading />} />
			</Suspense>
		</React.StrictMode>,
		document.getElementById('root')
	);
} else if (kitaharaDomains.includes(window.location.hostname)) {
	ReactDOM.render(
		<React.StrictMode>
			<Suspense fallback={<ColorfulLoading />}>
				<KitaharaPage loading={<ColorfulLoading />} />
			</Suspense>
		</React.StrictMode>,
		document.getElementById('root')
	);
} else if (kancolleDomains.includes(window.location.hostname)) {
	ReactDOM.render(
		<React.StrictMode>
			<Suspense fallback={<ColorfulLoading />}>
				<KancollePage loading={<ColorfulLoading />} />
			</Suspense>
		</React.StrictMode>,
		document.getElementById('root')
	);
} else {
	ReactDOM.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
		document.getElementById('root')
	);
}

interface Metrics {
	date: string;
	domain: string;
	name: string;
	path?: string;
	metric: string;
	value: number;
}

function debounce(func: (...args: any) => any, timeout = 30 * 1000){
	let timer: NodeJS.Timeout;
	let buffer: Metrics[] = [];
	let lastSend = new Date();
	return (metrics: Metrics[]) => {
		clearTimeout(timer);
		buffer.push(...metrics);
		const send = () => {
			const send = buffer;
			buffer = [];
			lastSend = new Date();
			func(send); 
		};
		if (buffer.length > 250) {
			timer = setTimeout(send, 0);
			return;
		}
		if (metrics.every(m => m.path === "/health/metricData")) {
			return;
		}
		if (lastSend.getTime() < new Date().getTime() - 30000) {
			timer = setTimeout(send, 0);
			return;
		}
		timer = setTimeout(send, timeout);
	};
}

const reportMetrics = debounce((metrics: Metrics[]) => {
	// TODO: Fix one day
	// Post("/health/metricData", {
	// 	data: metrics,
	// });
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals((x: any) => {
	reportMetrics([{
		date: new Date().toISOString(),
		domain: window.location.hostname,
		name: "web-vital",
		metric: x.name,
		value: x.value,
	}])
});

const observer = new PerformanceObserver((list) => {
	const metrics = list.getEntries().flatMap((entry: any) => {
		if (entry.deliveryType === "cache") {
			return [];
		}
		const url = new URL(entry.name);
		if (!url.pathname.startsWith("/")) {
			return [];
		}
		const preRequest = entry.requestStart - entry.startTime;
		const request = entry.responseStart - entry.requestStart;
		const response = entry.responseEnd - entry.responseStart;
		const total = entry.responseEnd - entry.startTime;

		const metric = {
			date: new Date().toISOString(),
			domain: window.location.hostname,
			name: "resource",
			path: url.pathname + url.search,
			data: entry
		}
		return [
			{ ...metric, metric: "pre-request", value: preRequest },
			{ ...metric, metric: "request", value: request },
			{ ...metric, metric: "response", value: response },
			{ ...metric, metric: "total", value: total },
		];
	});
	if (metrics.length > 0) {
		reportMetrics(metrics);
	}
});
  
observer.observe({ type: "resource", buffered: true });